/**
 * Created by SH: 02/20/2020
 */


import { Point } from "pixi.js";

import { PunkEngineController } from "./PunkEngineController";
import { ReelEngineManager } from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineManager";
import { IReelEngineConfig } from "@nolimitcity/slot-game/bin/core/engines/reel/engine/IEngine";
import { IDimConfig, ResizeHelper, LayoutDimData } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { PunkSymbolData } from "./config/PunkSymbolData";
import { IExpandAnimateConfig } from "./PunkEnginePlayer";
import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { GameConfig } from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import { ReelEngineController, ReelState } from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineController";
import { TimeCheckPoints } from "@nolimitcity/slot-game/bin/core/utils/TimeCheckPoints";
import { GameSetting } from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { TimelineMax } from "gsap";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { JurisdictionEvent } from "@nolimitcity/slot-game/bin/core/jurisdiction/JurisdictionEvent";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";

export class PunkEngineManager extends ReelEngineManager{

    private static minimumSpinTime: number = 0;
    protected static readonly reelDim:IDimConfig = {
        dimOrientation : {
            landscape :{
                scale:      new Point( 1, 1),
                position:   new Point( 15, 140),
                layout :{
                    left:   new Point( 15, 140),
                    right:  new Point( 15, 140)
                }
            },
            portrait :{
                scale:      new Point( 1, 1),
                position:   new Point( 15, 100)
            }
        },
        WIDTH: 900,
        HEIGHT: 540,
    };

    public get dim():LayoutDimData{ return PunkEngineManager.dim; };
    public static get dim():LayoutDimData{ return ResizeHelper.calcDim(this.reelDim); };

    public get AllReels():PunkEngineController[]{ return PunkEngineManager.AllReels; };
    public static get AllReels():PunkEngineController[]{ return <PunkEngineController[]>this._reels; };

    // public static getReel(ID:number):PunkEngineController{ return <PunkEngineController>super.getReel(ID); };

    protected createEngineControllers(config:IReelEngineConfig):void{
        for(var id = 0; id < config.REEL_AMOUNT; id++){
            PunkEngineManager._reels.push(new PunkEngineController({
                reelID:id,
                engine_config: config
            }));
        }
    }

    protected initialize():void{
        PunkSymbolData.InitSymbolData();
        this.AllReels.forEach(reel => {
            reel.initReel();
            reel.onStageResized(this.dim);
        });
    }

    addEventListeners(): void {
        super.addEventListeners();
        // Fetch the minimum time set from the server.
        EventHandler.addEventListener(this, JurisdictionEvent.MINIMUM_STOP_TIME, (event: GameEvent) => PunkEngineManager.minimumSpinTime = event.params[0]);
    }

    public static onExpandSymbol(data:IExpandAnimateConfig):void{
        if(data.reelID == undefined){
            Logger.warn("Trying to nudge an unknown reel, Skips.");
            return;
        }
        for (var i = 0; i < this.AllReels.length; i++){
            if(data.reelID && data.reelID.indexOf(i) >= 0 || !data.reelID)
                this.getReel(i).onExpandSymbol(data);
        }
    };

    public static getReelPos(reelIndex:number):Point {
        return  MathHelper.pointAdd(GameConfig.instance.REEL_ENGINE_POSITIONS![reelIndex], this.dim.position);
    }

    public static get getLastSpinningReel(): PunkEngineController {
        for (let r: number = this.AllReels.length - 1; r > 0; r--)
            if (this.getReel(r).isActive && this.getReel(r).state.isSpinning)
                return <PunkEngineController>this.getReel(r);
        return <PunkEngineController>PunkEngineManager.getReel(0);
    }

    private static stopDelays: number[] = [];
    public static stopReels(delays: number[]): number {
        const restDurr: number = this.calcRestWithDesired([delays[delays.length - 1]]);

        if (restDurr > 0) for (let i: number = 0; i < delays.length; i++) delays[i] += restDurr;

        this.stopDelays = delays;

        this.stopNextReel();

        return this.getLastStopTime() + delays[PunkEngineManager.getLastSpinningReel.reelID];
    }

    public static getNextRReelID(reelID:number):number {
        for (var r = reelID + 1; reelID < this.AllReels.length; reelID++)
            if (r < this.AllReels.length )
                return r;
        return -1;
    };

    // When the reels are spinning. The time between the Step and Stop can shift frame by frame.
    // This makes it impossible to calculate the perfect stop between reels without any of them stopping before one or the another.
    // To solve this, the the EngineManager will help the controllers to stop at the correct order no matter what.
    protected static tlStop: TimelineMax;
    protected static stopNextReel(): void {

        // Fetch the next Reel which is in the current "Step"-state, it goes from 0-n and return -1 if there is nothing.
        // To change the order it should check on, override this function to put your own preference.
        const steppingID: number = this.findFirstReelWithState(ReelState.STEP);

        // If there is a Step that should be stopped, trigger. Otherwise, skip and do nothing.  

        if (steppingID >= 0) {
            const delay: number = steppingID == 0 ? this.stopDelays[steppingID] : this.stopDelays[steppingID] - this.stopDelays[steppingID - 1];
            // If Quickstop triggers, abort the current tl and replace it with a new one.
            this.tlStop = Helper.timeLineKiller(this.tlStop, new TimelineMax({
                onComplete: () => {
                    if (!this.getReel(steppingID).state.willStop) this.getReel(steppingID).stopSpin();
                    this.stopNextReel();
                }
            }))

            // Get the extra delay from the current stopping reel from it's ongoing step -> stop transition.
            if (this.getReel(steppingID).state.willStop)
                this.tlStop.to(this, this.getReel(steppingID).getPlayTime(), {});
            else
                this.tlStop.to(this, delay, {});
        } else {
            
        }
    }

    public static updateNextActivated(): void {
        this.AllReels.forEach(r => r.stopVisibleCompleted());
    }

    public static getReel(ID: number): PunkEngineController {
        for (var searchID: number = 0; searchID < this._reels.length; searchID++)
            if (this._reels[searchID].reelID == ID) return <PunkEngineController>this._reels[searchID];
        debugger;
        throw console.error("Can't find the reel with ID: " + ID);
    };

    private static getLastStopTime(): number {
        const rc: ReelEngineController = PunkEngineManager.getLastSpinningReel;
        return rc.getNextAnimationTime() > rc.getPlayTime() ? rc.getNextAnimationTime() : rc.getPlayTime();
    }

    private static getTimeLeft(): number {
        const timeGone: number = TimeCheckPoints.getCheckPointTime("Bet") * 0.001;
        const minimumTime: number = GameSetting.isFastSpin ? GameConfig.instance.REEL_ENGINE_CONFIG!.DURATION.QUICK_SPIN_TIME : this.minimumSpinTime > 0 ? this.minimumSpinTime * 0.001 : GameConfig.instance.REEL_ENGINE_CONFIG!.DURATION.SPIN_TIME;

        return PunkEngineManager.isQuickStop ? 0 : Math.max(minimumTime - timeGone, 0);
    }

    private static getStartOffset(): number { return Math.max(this.getTimeLeft() - this.getLastStopTime(), 0) };

    private static calcRestWithDesired(initArrayWithValues: number[]): number {
        return Math.max(((this.getStartOffset()) - initArrayWithValues.reduce((a, b) => a + b, 0)), 0);
    };
}